import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-block-highlight',
    templateUrl: './block-highlight.component.html',
    styleUrls: ['./block-highlight.component.scss'],
    standalone: false
})
export class BlockHighlightComponent implements OnInit {

    @Input() item: any;
    content: any;
    icon: string = '';
    textColor: string = 'var(--gray-color)';
    backgroundColor: string = '#fffff';
    iconColor: string = 'var(--gray-color)';

    constructor() {
    }

    ngOnInit() {
        this.content = this.item.data.content;
        this.icon = this.item.data.icon.replace('fas', 'fa').replace('fab', 'fa');
        this.textColor = this.item.data.textColor;
        this.backgroundColor = this.item.data.backgroundColor;
        this.iconColor = this.item.data.iconColor;
    }
}
